import axios, { AxiosInstance } from 'axios';
import { getApiEnvByHost } from '@/utils/environment';
import { CreateQuoteRequest, CreateQuoteResponse, CurrencySettings } from '../types/automaticCurrencyConversion';

export const client = (clientSecret: string, headers: Record<string, string> = {}): AxiosInstance => {
  return axios.create({
    baseURL: `https://checkout${getApiEnvByHost()}.airwallex.com/api`,
    headers: { 'content-type': 'application/json', 'client-secret': `Bearer ${clientSecret}`, ...headers },
  });
};

export const getCurrencySettings = async (clientSecret: string): Promise<CurrencySettings> => {
  const { data } = await client(clientSecret).get('/v1/pa/config/currency_settings');
  return data;
};

export const createQuote = async (request: CreateQuoteRequest): Promise<CreateQuoteResponse> => {
  const { paymentCurrency, paymentAmount, targetCurrency, clientSecret } = request;
  const requestPayload = {
    payment_currency: paymentCurrency,
    target_currency: targetCurrency,
    type: 'currency_switcher',
    payment_amount: paymentAmount,
  };
  const { data } = await client(clientSecret).post('/v1/pa/quotes/create', requestPayload);
  return data;
};
